// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__oeSH4","isAnchor":"Tag_isAnchor__jgW3J"};